
import { useSearchParams } from "react-router-dom"
import { GoogleLogin } from 'react-google-login';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function Invite()
{

const [params,setParams]= useSearchParams();
const [gogle,setgogle]= useState([]);
const [name,setName]= useState([]);
const [mo,setMo]= useState([]);
const [mg,setMg]= useState([]);
const [id,setId]= useState("")


const team=params.get("team");

const client_Id="968127370331-hlrg0jrtkvpsqv6en52ci43ieqtn4u2o.apps.googleusercontent.com";
const navigate = useNavigate();

useEffect(()=>{
     const a= async ()=>{
        var res= await axios.get(`https://spliteasy.onrender.com/team/name/${team}`);
        console.log(res);
        setgogle(res.data[0].google)
        setName(res.data[0].names)
        setMg(res.data[0].moneygiven)
        setMo(res.data[0].moneyowed)
        setId(res.data[0]._id)
        
     }
     a();
},[])
const responseGoogle= async (res)=>{
   sessionStorage.setItem("gid", res.googleId);
sessionStorage.setItem("gname",res.profileObj.name);
   update(res.googleId,res.profileObj.name.split(" ")[0])
 const handleClick = () => {
    //  console.log(res.profileObj.name)
    navigate(`/all`);
}
handleClick();
}

const update=async (i,n)=>{
    gogle.push(i);
    mg.push(parseInt(0))
    mo.push(parseInt(0))
    name.push(n)

        console.log(gogle)
        const data={
            "google":gogle,
            "names": name,
            "moneygiven": mg,
            "moneyowed": mo,
                  }
        await axios.put(`https://spliteasy.onrender.com/update/${id}`,data).then(()=>{
            console.log("ok")
        })
}

    return(
        <div>
            <p className="invitetitle">SplitEasy</p>
        <div className="invitebox">
            <div className="boxcontent">
       <h2 className="invite">You have been invited to join</h2>
      
       <h1 className="teaminvite">{team}</h1>
       <div>
       <GoogleLogin
    clientId={client_Id}
    buttonText="Login to join"
    onSuccess={responseGoogle}
    onFailure={responseGoogle}
    cookiePolicy={'single_host_origin'}
  />
       </div>
       </div>
        </div>
        </div>
    )
}